<script>
    import {createEventDispatcher} from "svelte";

    export let locations = [];
    export let location = null;
    export let placeholder = null;
    export let required;

    let location_id = location ? location.id : "";
    let oldLocation = location;

    const dispatch = createEventDispatcher();

    const onLocationChange = () => {
        location = locations.find(x => x.id == location_id);
        oldLocation = location;
        dispatch("change", location);
    }

    $: if (location && oldLocation != location) {
        location_id = location.id;
        oldLocation = location;
    }
</script>

<select class="form-select" bind:value={location_id} on:change={onLocationChange} {required}>
    {#if placeholder}
        <option value="" disabled>{placeholder}</option>
    {/if}
    {#each locations as item}
        <option value="{item.id}">{item.name}</option>
    {/each}
</select>